<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentScreenshot /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentScreenshot from '@/components/worker/dashboard/modules/activity/screenshot/ContentScreenshot.vue'

export default 
{
  name: 'Screenshot',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentScreenshot
  }
}
</script>
<style>

</style>